/* eslint-disable import/no-extraneous-dependencies */
import * as React from 'react';
import { Typography } from '@tvg/fuse/typography';
import { IconElement } from '@tvg/fuse/icon-element';
import { IconCheck, IconClose } from '@tvg/fuse/icon/all';
import styles from './FeatureBullet.module.css';

interface Props {
  featureBullet: string;
  isCovered: boolean;
}

export function FeatureBullet({ featureBullet, isCovered }: Props) {
  return (
    <div className={styles.wrapper}>
      <IconElement
        className={styles.icon}
        color={isCovered ? 'var(--color-universal-greenMid)' : 'var(--color-universal-redMid)'}
        icon={isCovered ? <IconCheck /> : <IconClose />}
        responsiveSize="medium"
        dataTestId={isCovered ? 'covered-insurance-icon' : 'not-covered-insurance-icon'}
        srLabel={isCovered ? 'covered' : 'not covered'}
      />
      <Typography size="m1" tag="p" type="paragraph" dataTestId="insurance-bullet-description">
        {featureBullet}
      </Typography>
    </div>
  );
}

export default FeatureBullet;
